import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetBusinessesRequest } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/GetBusinesses.pb'
import { GetBusinessesResponse } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/GetBusinesses.pb'

export const getBusinesses = (request: GetBusinessesRequest, options?: CashRequestOptions) =>
  post<GetBusinessesRequest, GetBusinessesResponse>('/2.0/cash/get-businesses', request, {
    ...options,
    rejectOnError: true,
  })
